import {CountryCode} from "common/geo/constants/countries";

const countriesWithRegistrationProvinces = [CountryCode.Thailand];

export const isProvinceSelectionEnabled = (country: string) =>
    countriesWithRegistrationProvinces.includes(country as CountryCode);
